export const NODE_HEIGHT = 64;
export const NODE_WIDTH = 252;
export const NODE_Y_GAP = 50;
export const NODE_X_GAP = 100;
